import type { Locations } from './types/location';
import { KioskCommand } from './postKioskApi';
import { usePostKioskApi } from './usePostKioskApi';

export async function fetchLocations(): Promise<Locations> {
  const postKioskApi = usePostKioskApi();
  return await postKioskApi<Locations>(KioskCommand.fetchCompanies);
}
